import { ReducerHandler, ReducerAction } from '../../Types';
import { StoreThemes } from '../../Types/StoreTypes';
import {
    SET_ALL_THEMES,
    SET_SELECTED_THEME,
    SET_SELECTED_THEME_SWITCHER_STATE,
    SET_CURRENT_THEME_COLOR,
} from '../Actions/themesActions';

const initialState = {
    allThemes: {},
    selectedTheme: '',
    themeSwitcherState: '',
    currentThemeColor: '',
} as StoreThemes;

const themesReducerMap: Record<string, ReducerHandler<StoreThemes>> = {
    [SET_ALL_THEMES]: (state, action) => ({ ...state, allThemes: action.payload }),
    [SET_SELECTED_THEME]: (state, action) => ({ ...state, selectedTheme: action.payload }),
    [SET_SELECTED_THEME_SWITCHER_STATE]: (state, action) => ({ ...state, themeSwitcherState: action.payload }),
    [SET_CURRENT_THEME_COLOR]: (state, action) => ({ ...state, currentThemeColor: action.payload }),
};

function themesReducer(state = initialState, action: ReducerAction): StoreThemes {
    const handler = themesReducerMap[action.type];
    return handler ? handler(state, action) : state;
}

export default themesReducer;
